import React from "react";
import "./Footer.scss";

/*   Images */
import logo from "../../Assets/Images/logoWhite.png";


function Footer() {
  return (
    <div id="footer">
      <div className="footerContainer">
        <img className="navlogo" src={logo} alt="logo" />
        <ul>
          <p className="listHeader">Website</p>
          <li>
            <a href="/#features" className="listText">
              Features
            </a>
          </li>
          <li>
            <a href="/#about" className="listText">
              About
            </a>
          </li>
          {/* <li><a href='/#success' className='listText'>Success</a></li> */}
          <li>
            <a href="/#join" className="listText">
              Join
            </a>
          </li>
        </ul>
        <ul>
          <p className="listHeader">Get Help</p>
          {/* <li>
            <a href="/#testimonials" className="listText">
              Testimonies
            </a>
          </li> */}
          <li>
            <a href="/#faq" className="listText">
              FAQs
            </a>
          </li>
        </ul>
        <ul>
          <p className="listHeader">Legal</p>
          <li>
            <a href="/terms" className="listText">
              Terms of Service
            </a>
          </li>
          <li>
            <a href="/privacy" className="listText">
              Privacy Policy
            </a>
          </li>
        </ul>
        <div className="socialContainer">
          <a href='https://whop.com/frugal-szn-1' target="_blank">
            <div className="socialLogoDiscord" />
          </a>
          <a href='https://twitter.com/Frugalszn' rel="noreferrer" target="_blank">
            <div className="socialLogoTwitter" />
          </a>
          <a href='https://www.instagram.com/frugalseason/' rel="noreferrer" target="_blank">
            <div className="socialLogoInstagram" />
          </a>
        </div>
      </div>
      <p className="copyrightText">© Frugal SZN 2022, All Rights Reserved</p>
    </div>
  );
}

export default Footer;
